import { BaseApiModel } from './BaseApiModel';

export class UploadPreViolationFile extends BaseApiModel {
  public contractId: string;
  public type: string;
  public file: string;
}
